module.exports = __webpack_public_path__ + "img/missionaries26_2019_7-7-2021.e767ee9c.jpg";